import React, { useEffect } from "react";
import {
  ERROR_TYPE,
  WARNING_TYPE,
  INFO_TYPE,
  SERVER_WARNING_TYPE,
  SUCCESS_TYPE,
  DEFAULT_SUCCESS_MESSAGE,
  DEFAULT_SUCCESS_TITLE,
} from "../redux/constants/messageTypes";
import {
  DATA_LOAD_STATUS,
  CHECKIN_PROCESS_TYPE,
} from "../redux/constants/metaData";
import { useMetadata } from "../redux/hooks/useMetadata";
import { useCheckin } from "../redux/hooks/useCheckin";
import { useTools } from "../redux/hooks/useTools";
import { toast } from "react-toastify";
import {
  ErrorToast,
  SuccessToast,
  toastConfig,
} from "../components/common/ToastNotification";
import { getValidValue } from "../functions/helperMethod";
import { isValidPlayload } from "../functions/reduxMethod";
import ReusableMessageDialog from "./popupModals/ReusableMessageDialog";

export const MessageBox = () => {
  const metadata = useMetadata();
  const { checkinProgresseType } = useCheckin();
  const { onMessageBoxOkClick, onCheckinDocumentProgress } = useTools();
  const openMessageBox = metadata.openMessageBox;
  const messageBoxInfo = metadata.messageBoxInfo;
  const displayDetailsButton = metadata.displayDetailsButton;

  let title = messageBoxInfo?.type;
  const toastTitle = messageBoxInfo?.title;
  let message = messageBoxInfo?.message;
  const errorMessage = messageBoxInfo?.errorMessage ?? "";
  const domain = messageBoxInfo?.domain;

  useEffect(() => {
    if (openMessageBox && messageBoxInfo?.type === ERROR_TYPE) {
      const toastId = `error-${toastTitle?.trim() ? toastTitle : title}-${
        typeof errorMessage === "string"
          ? errorMessage
          : message || "Something went wrong"
      }`;
      let messageDescription = getValidValue(errorMessage, message);
      messageDescription = isValidPlayload(domain)
        ? `${domain}: ${messageDescription}`
        : messageDescription;
      const errorTitle = isValidPlayload(domain)
        ? `We Couldn't Complete ${domain}`
        : "We Couldn't Complete Your Request";
      toast(
        <ErrorToast title={errorTitle} description={messageDescription} />,
        { ...toastConfig.error, toastId }
      );
      onMessageBoxOkClick(false);
    }

    if (openMessageBox && messageBoxInfo?.type === SUCCESS_TYPE) {
      const toastId = `success-${toastTitle?.trim() ? toastTitle : title}-${
        typeof message === "string" ? message : "Success"
      }`;
      const successMessage = getValidValue(message, DEFAULT_SUCCESS_MESSAGE);
      const successTitle = getValidValue(toastTitle, DEFAULT_SUCCESS_TITLE);
      toast.success(
        <SuccessToast title={successTitle} description={successMessage} />,
        { ...toastConfig.success, toastId }
      );
      onMessageBoxOkClick(false);
    }
  }, [openMessageBox, messageBoxInfo]);

  if (
    messageBoxInfo?.type === ERROR_TYPE ||
    messageBoxInfo?.type === SUCCESS_TYPE
  ) {
    return null;
  }

  let variant = "error";
  if (title === WARNING_TYPE || title === SERVER_WARNING_TYPE) {
    variant = "warning";
    if (title === SERVER_WARNING_TYPE) {
      title = message;
      message = errorMessage;
    }
  } else if (title === INFO_TYPE) {
    variant = "info";
  }

  const handleClose = () => {
    onMessageBoxOkClick(false);
    if (checkinProgresseType === CHECKIN_PROCESS_TYPE.checkin) {
      onCheckinDocumentProgress(DATA_LOAD_STATUS.completed);
    }
  };

  return (
    <ReusableMessageDialog
      isOpen={openMessageBox}
      onClose={handleClose}
      title={title}
      message={message}
      errorMessage={errorMessage}
      showDetailsButton={displayDetailsButton}
      variant={variant}
    />
  );
};

export default MessageBox;
